import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';

import {aspectsSchema, AspectsType} from './review-aspect-type';

export function getAspectUrl(q: string, aspectIds?: Array<number>): string {
    return `/v2/reviews-analytics/stats/aspects/search/?${objectToUrlParameters(
        serializeToURLParameters({
            q,
            aspectIds,
        })
    )}`;
}

export function fetchAspects(q: string, aspectIds?: Array<number>): Promise<Array<AspectsType>> {
    return fetchAndDeserialize(getAspectUrl(q, aspectIds), aspectsSchema);
}
